import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { environment } from  '../../../environments/environment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { map } from 'rxjs';

interface INote{
  caseNoteCreatedByUser:string;
	caseNoteLastChangeDateTime:string;
	caseNoteText:string;
  caseNoteTypeName:string;
	caseUUID:string;
}

class DisputeAttachment{
  documentType!: string;
  documentNumber!: string; 
  documentPart!: string;
	documentVersion!: string;
	applicationId!: string;
	fileId!: string;
  filename!: string;
}

@Component({
  selector: 'app-dispute-details',
  templateUrl: './dispute-details.component.html',
  styleUrls: ['./dispute-details.component.css']
})
export class DisputeDetailsComponent implements OnInit{

  disputeDetails :any;
  disputeNotes : Array<INote> = [];
  userName!:String;
  noteText:String | undefined;
  disputeAttachment: DisputeAttachment = new DisputeAttachment();
  showLoader:boolean= false;
  showError: boolean = false;
  listOfAttachment : Array<DisputeAttachment> = [];
  @ViewChild('myInput')
  myInputVariable!: ElementRef;

  message: any;

  textMsg:any;

  constructor(private http: HttpClient, private modalService: NgbModal){
    this.disputeDetails = history.state.dispute;
    console.log(this.disputeDetails);
    this.getDisputeDetailsByCaseID(this.disputeDetails.CaseUUID);
    this.fetchAttachment(this.disputeDetails.CaseUUID);
  }

  ngOnInit() {
   var keyname = JSON.parse(localStorage.getItem("msal.account.keys")||'[]');

   var clientInfo = JSON.parse(localStorage.getItem(keyname[0])||'');

   this.userName = (clientInfo.name || '').trim();

  }

  getDisputeDetailsByCaseID(CaseID: any) {
    this.disputeNotes = [];
    let logTraceJSON: any = { 'eventSource': 'getDisputeDetailsByCaseID', 'caseID': CaseID };
    const headers = new HttpHeaders({
        'X-Log-Trace': JSON.stringify(logTraceJSON),
    });
    this.http.get(environment.serverURL + environment.brimURI + 'disputeDetailsByCaseId/' + CaseID, {headers}).subscribe((res: any) => {
      console.log(res);
      res.value.forEach((element: any) => {
        var note ={
          "caseNoteCreatedByUser":element.CaseNoteCreatedByUser,
          "caseNoteLastChangeDateTime":element.CaseNoteLastChangeDateTime,
          "caseNoteText":element.CaseNoteText,
          "caseNoteTypeName":element.CaseNoteTypeName,
          "caseUUID":element.CaseUUID
        }
        this.disputeNotes.push(note);
      });
      
      console.log(this.disputeNotes);
    }, (err:any) => {
      console.log(err);
    });
  }

  fetchAttachment(CaseID:any){
    this.listOfAttachment = [];
    let logTraceJSON: any = { 'eventSource': 'getDisputeAttachmentsByCaseID', 'caseID': CaseID };
    const headers = new HttpHeaders({
        'X-Log-Trace': JSON.stringify(logTraceJSON),
    });
    this.http.get(environment.serverURL + environment.brimURI + 'dispute/attachments/' + CaseID, {headers}).subscribe((res: any) => {
      console.log(res);
      res.forEach((element: any) => {
        var file ={
          "documentType":element.documentType,
          "documentNumber":element.documentNumber,
          "documentPart":element.documentPart,
          "documentVersion":element.documentVersion,
          "applicationId":element.applicationId,
          "fileId":element.fileId,
          "filename":element.filename
        }
        this.listOfAttachment.push(file);
      });
      
      console.log(this.listOfAttachment);
    }, (err:any) => {
      console.log(err);
    });
  }

  addNotes(){
    var note ={
      "caseNoteCreatedByUser":'',
      "caseNoteLastChangeDateTime":'',
      "CaseNoteText":this.noteText,
      "caseNoteTypeName":'',
      "CaseUUID":this.disputeDetails.CaseUUID
    }
    let logTraceJSON: any = { 'eventSource': 'postDisputeNote', 'payload': note, 'caseId': this.disputeDetails.CaseUUID };
    const headers = new HttpHeaders({
        'X-Log-Trace': JSON.stringify(logTraceJSON),
    });
    this.http.post(environment.serverURL + environment.brimURI + 'disputeNote/',note, {headers}).subscribe((res: any) => {
      console.log(res);
      this.noteText = '';
      this.getDisputeDetailsByCaseID(this.disputeDetails.CaseUUID);
    }, (err:any) => {
      console.log(err);
    });
  }

  download(file: DisputeAttachment,content:any) {
    this.showLoader = true;
    this.message = "Download Attachments!"
    this.textMsg = "We are downloading your attachment. Please wait for sometime.";
    this.modalService.open(content);
    let logTraceJSON: any = { 'eventSource': 'downloadDisputeAttachment', 'fileInfo': encodeURIComponent(JSON.stringify(file)) };
    const headers = new HttpHeaders({
        'X-Log-Trace': JSON.stringify(logTraceJSON),
    });
    this.http.get(environment.serverURL + environment.brimURI + 'dispute/attachment?disputeAttachment='+encodeURIComponent(JSON.stringify(file)), {headers, responseType: 'arraybuffer'})
    .pipe(map((res:any)=>{
      return {  
        filename: file.filename,
        data:  res,
        };
    })).subscribe((response:any) => {

      console.log(response.data);
      console.log(response.filename);
      console.log(response.data.byteLength);
      if (response.data.byteLength > 0) {
        var binaryData = [];
        binaryData.push(response.data);
        var url = window.URL.createObjectURL(new Blob(binaryData));
        this.downloadFile(url, response.filename);
        this.showLoader = false;
        this.showError = false;
        this.message = "Download Attachments!";
        this.textMsg = "Attachment has been downloaded successfully.";
      } else {
        this.showLoader = false;
      this.showError = true;
      this.message = "Error!";
      this.textMsg ="Something went wrong while downloading the dispute attachment, please retry again or contact support team.";
      }
    }, (error: any) => {
      this.showLoader = false;
      this.showError = true;
      this.message = "Error!";
      this.textMsg ="Something went wrong while downloading the dispute attachment, please retry again or contact support team.";
    });
  }
  /**
   * Method is use to create temp anchor tag for download file.
   * @param url - url to download with Buffer data
   * @param fielName - document name.
   */
  downloadFile(url: string, fielName: string) {
    var a = document.createElement('a');
    document.body.appendChild(a);
    a.setAttribute('style', 'display: none');
    a.setAttribute('target', 'blank');
    a.href = url;
    a.download = fielName;
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }

fileChange(event:any,content:any) {
  let fileList: FileList = event.target.files;

  if (fileList.length < 1) {
    return;
  }
  
  let file: File = fileList[0];
  let formData:FormData = new FormData();
  formData.append('file', file, file.name)
  
  let headers = new HttpHeaders()
    // .set('Content-Type', 'multipart/form-data')
    .set('Accept', 'application/json');
  let logTraceJSON: any = { 'eventSource': 'uploadDisputeAttachment', 'payload': formData, 'caseId': this.disputeDetails.CaseUUID };
  headers = headers.set('X-Log-Trace', JSON.stringify(logTraceJSON));
  let options = { headers: headers };
  this.showLoader = true;
  this.message = "Upload Attachments"
  this.textMsg = "We are uploading  your attachment. Please wait for sometime.";
  this.modalService.open(content);
  this.http.post(environment.serverURL + environment.brimURI + 'dispute/attachment/'+this.disputeDetails.CaseUUID, formData, options)
  .subscribe(
    (res:any) =>{
        console.log(res);
        this.fetchAttachment(this.disputeDetails.CaseUUID);
        this.showLoader = false;
        this.showError = false;
        this.message = "Upload Attachments!";
        this.textMsg = "Attachment has been uploaded successfully.";
       this.myInputVariable.nativeElement.value = "";
        return;
    },
    (err:any) => {
      this.showLoader = false;
      this.showError = true;
      this.message = "Error!";
      this.textMsg = "Something went wrong while uploading attachment, please retry again or contact support team.";
      console.log(err.message);
    }
)
}

closeDisputePopup() {
  this.modalService.dismissAll();
}

}


